import { MiscStoreData } from './miscSlice';

export const initialMiscStoreData: MiscStoreData = {
  referralDiscountCode: undefined,
  discountCodeNeedsValidation: false,
  preferredSubmitIntention: 'offer',
  dataProcessingAgreement: null
};
